import { MyTaskService } from "@/service/MyTaskService"
import { MyTaskData } from "@/types/Dakoku"
import { SoumuDakokuCheckWhereConditions } from "@/types/MyTask"
import OptionConst from "@/const/Option"
import { computed, ref, Ref } from "vue"
/*
 * 総務が確認する打刻情報を取得
 */
export function useSoumuCheckList() {
  let loading = ref(0)
  let isListError = ref(false)

  // 読み込み中か判断する
  const isListLoading = computed(() => {
    return !(loading.value === 0 || isListError.value)
  })

  // 一覧取得
  const myTaskList: Ref<MyTaskData[]> = ref([]);
  const totalDataCount: Ref<Number> = ref(0);
  const getDakokuSoumuCheckList = async (params: SoumuDakokuCheckWhereConditions) => {
    loading.value++

    // API
    const srv = new MyTaskService()
    const res = await srv.getDakokuSoumuCheckList(params)
    myTaskList.value = res.allList;
    totalDataCount.value = res.totalDataCount;
    loading.value--
  };

  const dakokuSyouninStatus = (statusId: number) => {
    const status = OptionConst.DAKOKU_SYOUNIN_STATUS_OPTION.find(item => item.val === statusId)
    if (status) {
      return status.label
    } else {
      return '-'
    }
  }

  return {
    isListLoading,
    isListError,
    getDakokuSoumuCheckList,
    dakokuSyouninStatus,
    myTaskList,
    totalDataCount,
  };
}
